<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--块1-->
			<div class="block_1">
				<div v-if="infoData" class="block_1_main">
					<div class="tit_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">{{ infoData.title }}</div>
						<div class="time">{{ infoData.fabu_time }}</div>
					</div>
					<div class="content_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						v-html="infoData.content"
					></div>
					<div class="btn_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div v-if="prevList" class="btn_el">
							<div class="tit">{{ $t('support.text5') }}</div>
							<div class="txt" @click="goInfo(prevList)">{{ prevList.title }}</div>
						</div>
						<div v-if="nextList" class="btn_el">
							<div class="tit">{{ $t('support.text6') }}</div>
							<div class="txt" @click="goInfo(nextList)">{{ nextList.title }}</div>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import { supportInfo } from '@/api/public';  //技术支持详情
import { UPURL } from '@/util/util';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			tipsList: [],
			nextList: null,
			prevList: null,
			webUrl: UPURL,
		}
	},
	created(){
		let that = this;
		//请求详情接口
		if(that.$route.params.supportInfoId) {
			that.getInfo(that.$route.params.supportInfoId.split('.')[0]);
		}else {
			that.$toast(that.$t('support.text7'));
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//请求数据
		getInfo(value) {
			let that = this;
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			supportInfo({ id: value }).then(res => {
				that.infoData = res.data.info;
				that.tipsList = res.data.list;
				that.nextList = res.data.nextinfo;
				that.prevList = res.data.preinfo;
				that.$toast.clear();
			});
		},
		//进入详情
		goInfo(value) {
			let that = this;
			// that.getInfo(value.id);
			// window.scrollTo(0, 0);
			that.$router.push({ name: 'SupportInfo', params: { supportInfoId: value.id + '.html' } });
			setTimeout(() => {
				window.location.reload();
			}, 300);
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块1
	.block_1{
		background: url(../../assets/img_public/news/news_bg_h5.webp) no-repeat 100% 100%;
		background-size: cover;
		.block_1_main{
			padding: 40px 20px;
			.btn_box{
				padding-top: 20px;
				.btn_el{
					display: flex;
					margin-top: 10px;
					padding: 20px 16px;
					background-color: #ffffff;
					border-radius: 8px;
					.txt{
						flex: 1;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 3;
						-webkit-box-orient: vertical;
					}
					.tit{
						width: auto;
						color: #A20073;
					}
				}
			}
			.content_box{
				padding-top: 30px;
				word-break: break-all;
			}
			.tit_box{
				padding-bottom: 20px;
				border-bottom: 1px solid #999999;
				text-align: center;
				.time{
					padding-top: 10px;
					color: #999999;
				}
				.tit{
					font-size: 24px;
					font-weight: bold;
				}
			}
		}
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box .content_box img{
	max-width: 100%;
	height: auto;
}
</style>